import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LayoutDashboard, LogOut, Crown } from 'lucide-react';
import { getUser, logout } from '../../utils/auth';

const AdminLayout = ({ children }) => {
  const user = getUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#FCFBF9]">
      {/* Admin Header */}
      <header className="bg-[#3E2723] text-white border-b border-[#2A1A17]" data-testid="admin-header">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-16">
            <Link to="/admin" className="flex items-center gap-3">
              <Crown className="h-7 w-7" strokeWidth={1.5} />
              <span className="font-serif text-xl font-medium">Crowns by Preshy - Admin</span>
            </Link>

            <div className="flex items-center gap-6">
              <Link to="/" className="text-white/80 hover:text-white transition-colors text-sm">
                View Public Site
              </Link>
              <div className="flex items-center gap-3 text-sm">
                <span className="text-white/80">{user?.full_name}</span>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
                >
                  <LogOut className="h-4 w-4" />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Admin Content */}
      <main className="py-8">
        {children}
      </main>

      {/* Simple Admin Footer */}
      <footer className="bg-white border-t border-[#E6DCD3] mt-auto">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6">
          <div className="text-center text-sm text-[#786E66]">
            <p>© {new Date().getFullYear()} Crowns by Preshy Admin Panel. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AdminLayout;
